import { isEmpty } from 'lodash/fp';

export const getPathItems = (path: string) => {
    const splitByBracket = path.split(/(?<='])|(?=\[')/g);
    const resultItems: string[] = [];
    splitByBracket.forEach((item) => {
        let tmpItem = item;
        if (item.startsWith('.')) {
            tmpItem = item.substring(1);
        }
        if (tmpItem.startsWith("['") && tmpItem.endsWith("']")) {
            // do not split on dot inside brackets e.g.foo['bar.baz']
            resultItems.push(tmpItem);
        } else {
            tmpItem.split('.').forEach((splitItem) => resultItems.push(splitItem));
        }
    });
    return resultItems;
};

const isBracketNotation = (value: string) =>
    value ? value.startsWith("['") && value.endsWith("']") : false;
export const parsePropertyName = (value: string) => {
    if (isBracketNotation(value)) {
        return value.substring(2, value.length - 2);
    }
    return value;
};

export const addItemToPath = (path: string, item: string) =>
    isBracketNotation(item) ? `${path}${item}` : `${path}.${item}`;

export const getExtractedColumnName = (path: string) => {
    const items = getPathItems(path).map(parsePropertyName);
    return items.join('_');
};

export const getPathLastItem = (path?: string) => {
    if (isEmpty(path)) {
        return null;
    }
    const lastItem = getPathItems(path).pop();
    return lastItem ? parsePropertyName(lastItem) : null;
};

export const getParentPath = (path: string) => {
    const lastPathItemLength = getPathItems(path)?.pop()?.length || 0;
    const parentPath = path.substring(0, path.length - lastPathItemLength);
    if (parentPath.endsWith('.')) {
        return parentPath.substring(0, parentPath.length - 1);
    }
    return parentPath;
};

export const getDirectChildrenForNodePath = (selectedPath: string, paths: string[]) => {
    const selectedPathItemsCount = getPathItems(selectedPath).length;

    return paths.filter((path) => {
        if (path.startsWith(`${selectedPath}.`) || path.startsWith(`${selectedPath}['`)) {
            const pathItemsCount = getPathItems(path).length;
            return pathItemsCount === selectedPathItemsCount + 1;
        }
        return false;
    });
};

type JsonSchema = string | null | { [key: string]: JsonSchema };

export const generateJsonSchemaFromPaths = (paths: string[]) => {
    const schema: JsonSchema = {};

    paths.forEach((path) => {
        let current = schema;
        const pathItems = getPathItems(path);
        const pathItemsCount = pathItems.length;
        for (let i = 0; i < pathItemsCount; i++) {
            const key = pathItems[i]!;
            if (!current[key]) {
                if (i === pathItemsCount - 1) {
                    current[key] = null;
                } else {
                    current[key] = {};
                }
            }

            // [TODO] Need to check
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            current = current[key];
        }
    });

    return schema;
};

export const getTreeNode = (path: string) => document.querySelector(`div[data-path="${path}"]`);
